// Generated by Melange

import * as Buhta_cabinet__AuthTemplate from "../../templates/AuthTemplate.js";
import * as Buhta_cabinet__LoginForm from "./LoginForm.js";
import * as Buhta_cabinet__LogoutForm from "./LogoutForm.js";
import * as Buhta_cabinet__RecoverForm from "./RecoverForm.js";
import * as Buhta_cabinet__RecoverPasswordForm from "./RecoverPasswordForm.js";
import * as Buhta_cabinet__RegisterForm from "./RegisterForm.js";
import * as JsxRuntime from "react/jsx-runtime";

function AuthPage(Props) {
  let tab = Props.tab;
  let payload = Props.payload;
  let tmp;
  switch (tab) {
    case /* Login */ 0 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__LoginForm.make, {
        payload: payload
      });
      break;
    case /* Logout */ 1 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__LogoutForm.make, {
        payload: payload
      });
      break;
    case /* Recover */ 2 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__RecoverForm.make, {
        payload: payload
      });
      break;
    case /* RecoverPassword */ 3 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__RecoverPasswordForm.make, {
        payload: payload
      });
      break;
    case /* Register */ 4 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__RegisterForm.make, {
        payload: payload
      });
      break;
  }
  return JsxRuntime.jsx(Buhta_cabinet__AuthTemplate.make, {
    children: tmp
  });
}

const make = AuthPage;

export {
  make,
}
/* Buhta_cabinet__AuthTemplate Not a pure module */
